
import { Directive, EventEmitter, HostListener, Input, Output } from "@angular/core";

@Directive({
    selector: '[drop-zone]',
    standalone: true
})
export class FileDragNDropDirective {
  @Output() private filesChangeEmitter : EventEmitter<File[]> = new EventEmitter();
  @Output() private dragoverEmitter : EventEmitter<void> = new EventEmitter();
  @Output() private dragleaveEmitter : EventEmitter<void> = new EventEmitter();

  @Input() allowedFilesExtensions : string[] | null = null;

  constructor() { }

  @HostListener('dragover', ['$event']) public onDragOver(evt: DragEvent){
    evt.preventDefault();
    evt.stopPropagation();
    this.dragoverEmitter.emit();
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt: DragEvent){
    evt.preventDefault();
    evt.stopPropagation();
    this.dragleaveEmitter.emit();
  }

  @HostListener('drop', ['$event']) public onDrop(evt: DragEvent){
    evt.preventDefault();
    evt.stopPropagation();
    this.dragleaveEmitter.emit();
    const files = evt.dataTransfer?.files;
    const valid_files : File[] = files ? Array.from(files) : [];
    if (this.allowedFilesExtensions) {
      const filtered_files = valid_files.filter(file => {
        const extension = file.name.split('.').pop()?.toLowerCase();
        return extension && this.allowedFilesExtensions?.includes(extension);
      });
      this.filesChangeEmitter.emit(filtered_files);
    } else {
      this.filesChangeEmitter.emit(valid_files);
    }
  }
}
